import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';

import {
  closePoNumberEdit,
  openPoNumberEdit,
  updatePoNumber,
} from '../actions/invoice-actions';
import { setTestId } from '../util/testUtils';
import LinkButton from './common/link-button';

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  bolded: {
    fontWeight: 'bold',
  },
  textField: {
    marginRight: theme.spacing(1),
  },
  edit: {
    marginLeft: theme.spacing(1),
  },
  saveButton: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    maxHeight: theme.spacing(4),
  },
  cancelButton: {
    marginLeft: theme.spacing(1),
    maxHeight: theme.spacing(4),
  },
  '@media (max-width: 600px)': {
    saveButton: {
      marginTop: theme.spacing(1),
      maxHeight: theme.spacing(4),
      marginBottom: theme.spacing(1),
      padding: 0,
    },
    cancelButton: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      maxHeight: theme.spacing(4),
      padding: 0,
      marginRight: theme.spacing(1),
    },
    textField: {
      marginLeft: theme.spacing(2),
    },
  },
});

class EditPaymentOrder extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleClosePoNumberEdit: PropTypes.func.isRequired,
    handlePoNumberOpenEdit: PropTypes.func.isRequired,
    handleUpdatePoNumber: PropTypes.func.isRequired,
    isEditing: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
    poError: PropTypes.string,
    poNumber: PropTypes.string.isRequired,
  };

  static defaultProps = {
    poError: '',
  };

  constructor(props) {
    super(props);
    const { poNumber } = this.props;
    this.state = { localPONumber: poNumber };
  }

  toggleEdit = () => {
    const { isEditing, handlePoNumberOpenEdit, handleClosePoNumberEdit } =
      this.props;

    if (isEditing) {
      handleClosePoNumberEdit();
    } else {
      handlePoNumberOpenEdit();
    }
  };

  handleUpdate = (e) => {
    this.setState({ localPONumber: e.target.value });
  };

  handleFormKeyDown = (event) => {
    // Handle Enter key like the submit button
    if (event.key === 'Enter') {
      this.handleSubmit();
    }
  };

  handleSubmit = () => {
    const { handleUpdatePoNumber } = this.props;
    const { localPONumber } = this.state;

    handleUpdatePoNumber(localPONumber);
  };

  render() {
    const { classes, isEditing, isSaving, poNumber, poError } = this.props;

    const { localPONumber } = this.state;

    return isEditing ? (
      <Grid container>
        <Grid className={classes.root} item sm={6} xs={12}>
          <TextField
            {...setTestId('poNumber')}
            autoFocus
            className={classes.textField}
            error={Boolean(poError)}
            fullWidth
            helperText={poError}
            inputProps={{
              maxLength: 25,
            }}
            onChange={this.handleUpdate}
            onKeyDown={this.handleFormKeyDown}
            placeholder="(Optional)"
            value={localPONumber}
          />
        </Grid>
        <Grid className={classes.root} item sm={6} xs={12}>
          <Button
            {...setTestId('savePoNumber')}
            className={classes.saveButton}
            color="primary"
            onClick={this.handleSubmit}
            variant="contained"
          >
            {isSaving ? <CircularProgress color="inherit" size={25} /> : 'Save'}
          </Button>
          <Button
            className={classes.cancelButton}
            onClick={this.toggleEdit}
            variant="outlined"
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    ) : (
      <div className={classes.root}>
        <Typography align="right" className={classes.bolded} gutterBottom>
          {poNumber}
        </Typography>
        <span className={classes.edit}>
          <LinkButton {...setTestId('editPoNumber')} onClick={this.toggleEdit}>
            edit
          </LinkButton>
        </span>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    invoice: { poNumber, isEditing, isSaving, poError },
  } = state;

  return {
    poNumber,
    isEditing,
    isSaving,
    poError,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleUpdatePoNumber: updatePoNumber,
      handlePoNumberOpenEdit: openPoNumberEdit,
      handleClosePoNumberEdit: closePoNumberEdit,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EditPaymentOrder));
